module.exports = __webpack_public_path__ + "img/nature-39.984ca19a.jpg";